import { render, staticRenderFns } from "./NewOnline.vue?vue&type=template&id=645e3349&"
import script from "./NewOnline.vue?vue&type=script&lang=js&"
export * from "./NewOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports